// Generated by ts-to-zod
import { z } from 'zod'

import { BLOCK_TYPE } from '../../../types/next/enums'

import { iBlockSchema, blockBaseSettingsSchema } from './baseBlock.zod'

export const numberSuggestionSchema = z.object({
  label: z.string(),
  value: z.string()
})

export const numberInputValueSchema = z.object({
  numberInput: z.string().optional().nullable(),
  numberUnit: z.string().optional(),
  frequencyUnit: z.string().optional()
})

const iconConfigSchema = z.any()

export const numberInputBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.NUMBER_INPUT),
  settings: blockBaseSettingsSchema.and(
    z.object({
      adornmentIcon: iconConfigSchema.optional(),
      unit: z
        .object({
          show: z.boolean(),
          label: z.string()
        })
        .optional(),
      format: z
        .object({
          show: z.boolean().optional(),
          validate: z.boolean().optional(),
          digitsBeforeDecimalPoint: z.number().optional(),
          decimalPlaces: z.number().optional()
        })
        .optional(),
      range: z
        .object({
          min: z.number(),
          max: z.union([z.number(), z.literal('Infinity')])
        })
        .optional(),
      suggestions: z.array(numberSuggestionSchema).optional(),
      suggestionIcon: z.string().optional()
    })
  )
})
